import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  sendDefaultPii: false,
  environment: import.meta.env.MODE,
});

// Suppress findDOMNode warnings in development
if (process.env.NODE_ENV === "development") {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === "string" &&
      args[0].includes("Warning: findDOMNode is deprecated")
    ) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
}
